import script from "./StudentTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentTable.vue?vue&type=script&setup=true&lang=ts"

import "./StudentTable.vue?vue&type=style&index=0&id=46ad1d23&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ad1d23"]])

export default __exports__